import { LayoutTabSection } from '../../_layouts/LayoutTabSection';
import { TitleText } from '../common/TitleText';
import { useFetch, CPLAT_API_ROUTES } from '@/api';
import { AxiosResponse } from 'axios';
import InfoFillGrayIcon from '@/assets/icons/InfoFillGrayIcon.svg?react';
import { Dialog, DialogTrigger, DialogContent } from '@/components/atoms/Dialog';
import { ChevronRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '@/routes';
import { useMembershipPreviewMode } from '@/components/membership/MembershipContentLock';
import { membershipReviewPreviewMarketInfoList } from '../membership-review-inquiry-mock';

type InquiryTutorialMarketInfo = {
  MarketNameEnglish: string;
  MarketIconUrl: string;
};

const TabSection = () => {
  return (
    <LayoutTabSection>
      <div className="flex items-center gap-[16px]">
        <TitleText title="문의 관리" />
        <TutorialDialog />
      </div>
    </LayoutTabSection>
  );
};

export default TabSection;

export const ENABLE_CHECK_INQUIRY = [
  'smartstore',
  'coupang',
  '11st',
  'gmarket-new',
  'auction-new',
  'cafe24',
  'talkstore',
  'shopby',
  'lotteon',
  'imweb',
];

const TutorialDialog = () => {
  const isPreviewMode = useMembershipPreviewMode();
  const { data: marketInfoRes, isLoading } = useFetch<AxiosResponse>(
    CPLAT_API_ROUTES.getMarketModel,
    {
      method: 'POST',
      config: {
        enabled: !isPreviewMode,
      },
    },
  );
  const marketInfoList: InquiryTutorialMarketInfo[] = isPreviewMode
    ? membershipReviewPreviewMarketInfoList
    : marketInfoRes?.data || [];
  const shouldShowDialogContent = isPreviewMode || (!isLoading && marketInfoList.length > 0);

  return (
    <Dialog>
      <DialogTrigger asChild>
        <button
          className="flex items-center gap-[2px] rounded-[8px] bg-white px-[10px] py-[6px] "
          data-membership-preview-interactive={isPreviewMode ? 'true' : undefined}
        >
          <InfoFillGrayIcon />

          <span className="text-gr-700 Body5M14">이용 방법 확인하기</span>
        </button>
      </DialogTrigger>
      {shouldShowDialogContent && (
        <DialogContent
          noCloseBtn
          className="w-[420px] p-[30px]"
          data-membership-preview-interactive={isPreviewMode ? 'true' : undefined}
        >
          <div className="flex flex-col gap-[10px]">
            <DialogTopSection marketInfoList={marketInfoList} />
            {!isPreviewMode && <DialogFooterSection />}
          </div>
        </DialogContent>
      )}
    </Dialog>
  );
};

const DialogTopSection = ({ marketInfoList }: { marketInfoList: InquiryTutorialMarketInfo[] }) => {
  return (
    <div className="flex flex-col gap-[10px]">
      <div className="flex flex-col gap-1 text-gr-800 Title3S18">
        <div>이제 셀러박스에서</div>
        <div>10개 마켓의 문의글을 처리할 수 있어요</div>
      </div>
      <div className="flex justify-center gap-[4px] rounded-[10px] bg-gr-50 p-[12px]">
        {ENABLE_CHECK_INQUIRY.map((marketName) => {
          const market = marketInfoList.find((item) => item.MarketNameEnglish === marketName);

          return market ? (
            <img
              key={market.MarketIconUrl}
              src={market.MarketIconUrl}
              className="h-[30px] w-[30px]"
              alt={market.MarketNameEnglish}
            />
          ) : null;
        })}
      </div>
      <ul className="list-outside   gap-[2px]  text-gr-500  Caption1M12">
        <li>*아임웹은 문의 답변을 처리할 수 있도록 준비중에 있어요.</li>
      </ul>
    </div>
  );
};

const DialogFooterSection = () => {
  const navigate = useNavigate();
  const handleClick = () => {
    navigate(ROUTES.marketRegister);
  };
  return (
    <div className="flex flex-col gap-[8px]">
      <div className="text-gr-800 Body5M14">아직 연동하지 않은 마켓이 있다면?</div>
      <button
        onClick={handleClick}
        className="flex w-fit items-center gap-[6px] rounded-[8px] bg-gr-100 px-[10px] py-[6px] text-gr-700 Body5M14"
      >
        마켓 추가연동 <ChevronRight className="h-[16px] w-[16px]" />
      </button>
    </div>
  );
};
